import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { GET_SPOUSAL_INFORMATION_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class GetSpousalInformationRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = GET_SPOUSAL_INFORMATION_URL;

  constructor(requestBody, paramList) {
    super();
    this.body = requestBody;
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
